import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
export type AnalyticsAccountSettingsQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type AnalyticsAccountSettingsQueryResult = { __typename?: 'Query' } & {
  analyticsAccountSettings?: GraphQLTypes.Maybe<
    { __typename?: 'AnalyticsAccountSettingsPayload' } & Pick<
      GraphQLTypes.AnalyticsAccountSettingsPayload,
      'accountId' | 'analyticsEnabled' | 'analyticsSharedUserEnabled'
    >
  >;
};

export const AnalyticsAccountSettingsDocument = gql`
  query analyticsAccountSettings($accountId: String!) {
    analyticsAccountSettings(accountId: $accountId) {
      accountId
      analyticsEnabled
      analyticsSharedUserEnabled
    }
  }
`;
